import React from 'react';
import { Container } from './style';
import AnswerOptionLabel from 'routes/surface/components/node-modal-form/components/questionnaire-node-modal/components/questionnaire-node-form/components/answer-option-label';

export interface AnswerOptionProps {
  value: any;
  onClick: Function;
  selected: boolean;
  disabled?: boolean;
  color: string;
  selectedColor: string;
}

const defaultProps = {
  label: '',
};

function AnswerOption(props: AnswerOptionProps) {
  const { selected, value, selectedColor, color } = props;

  function onClick() {
    props.onClick(value);
  }

  return (
    <Container
      onClick={onClick}
      color={color}
      selected={selected}
      selectedColor={selectedColor}
      disabled={props.disabled}>
      <AnswerOptionLabel type={value} />
    </Container>
  );
}

AnswerOption.defaultProps = defaultProps;

export default AnswerOption;
